import styles from './Onboard.less';
import searchSvg from '!!raw!svgo!./OnboardSearch.svg';
import refinementSvg from '!!raw!svgo!./OnboardRefinement.svg';
import feedbackSvg from '!!raw!svgo!./OnboardFeedback.svg';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { dismiss } from 'store/peekDown/peekDown';

const search = {
  title: 'We\'re still SEEK',
  message: 'You\'ll know what to do. Start by telling us what you\'re searching for.',
  messageClass: styles.message,
  image: searchSvg
};

const refine = {
  title: 'Search faster',
  message: 'Find exactly what you\'re looking for, faster.',
  messageClass: `${styles.message} ${styles.message_isRefine}`,
  image: refinementSvg
};

const feedback = {
  title: 'What do you think?',
  message: 'Your feedback will help us improve. Let\'s make this great.',
  messageClass: styles.message,
  image: feedbackSvg
};

const mapDispatchToProps = dispatch => ({
  gotItHandler: () => dispatch(dismiss())
});

@connect(null, mapDispatchToProps)
class Onboard extends Component {

  static propTypes = {
    gotItHandler: PropTypes.func.isRequired
  };

  getSvg(svg) {
    return <span className={styles.instructionImage} dangerouslySetInnerHTML={{ __html: svg }} />; // eslint-disable-line react/no-danger
  }

  getInstruction({ title, message, messageClass, image }) {
    return (
      <div className={styles.instruction}>
        { this.getSvg(image) }
        <p className={styles.title}>{ title }</p>
        <p className={messageClass}>{ message }</p>
      </div>
    );
  }

  render() {
    const { gotItHandler } = this.props;

    return (
      <div className={styles.root}>
        <p className={styles.heading}>Same SEEK, but better</p>
        <div className={styles.instructions}>
          { this.getInstruction(search) }
          { this.getInstruction(refine) }
          { this.getInstruction(feedback) }
        </div>
        <div className={styles.gotIt}>
          <p className={styles.gotItLink} onClick={gotItHandler}>Got It!</p>
        </div>
      </div>
    );
  }

}

export default Onboard;



/** WEBPACK FOOTER **
 ** ./app/components/Onboard/Onboard.js
 **/